import { useCallback, useState } from 'react';

export default (initialState = false) => {
  const [state, setState] = useState(initialState);
  const flip = useCallback(() => setState((value) => !value), [setState]);
  return [state, flip] as const;
};
